<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="4" sm="2" xl="1">
        <YearsProgressiveListDropDown
          :year="year"
          @yearChange="handleYearChange"
        ></YearsProgressiveListDropDown>
      </v-col>
      <v-col cols="8" sm="4" md="4" xl="2">
        <UsersDropDownList
          label="Internal Employee"
          :userId="userId"
          :clearable="true"
          :securityRoles="[ADMIN, MANAGER, SALES_PERSON, RECRUITER]"
          @userIdChange="handleUserIdChange"
        ></UsersDropDownList>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { SimpleDatePicker } from '@/components/shared/datePickers'
import { ClientsDropDownList } from '@/components/clients'
import { UsersDropDownList } from '@/components/users'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { YearsProgressiveListDropDown } from '@/components/years'
import { ADMIN, MANAGER, SALES_PERSON, RECRUITER } from '@/lib/constants/securityRoles'

export default {
  components: {
    SimpleDatePicker,
    ClientsDropDownList,
    UsersDropDownList,
    FilterButtons,
    FilterButtonsSmall,
    YearsProgressiveListDropDown
  },
  data () {
    return {
      ADMIN,
      MANAGER,
      SALES_PERSON,
      RECRUITER
    }
  },
  computed: {
    ...mapFields('gpToCostReportFilters', [
      'year',
      'userId'
    ])
  },
  methods: {
    ...mapActions('gpToCostReportFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleUserIdChange (value) {
      this.userId = value
    },
    handleYearChange (value) {
      this.year = value
    },
    handleClearClick () {
      this.clearFilters()
      this.$emit('clear')
    }
  }
}
</script>
